export const DOCUMENT_UPLOADER = 'page/DOCUMENT_UPLOADER';
